import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Spinner } from './ui';
import { type ReactNode } from 'react';

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { logado, carregando } = useAuth();

  if (carregando) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-ink-50">
        <Spinner className="h-10 w-10" />
      </div>
    );
  }

  if (!logado) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}
